import React from "react";
import UsersPermissions from "./UsersPermissions";
import CrudPage from "../components/CrudPage";
import { resources } from "../config/resources";

export const AssignmentsPage = () => <CrudPage config={resources.assignments} />;
export const MaintenancesPage = () => <CrudPage config={resources.maintenances} />;
export const DeadlinesPage = () => <CrudPage config={resources.deadlines} />;
export const CostsPage = () => <CrudPage config={resources.costs} />;
export const RefuelingsPage = () => <CrudPage config={resources.refuelings} />;
export const DamagesPage = () => <CrudPage config={resources.damages} />;
export const FinesPage = () => <CrudPage config={resources.fines} />;
export const SuppliersPage = () => <CrudPage config={resources.suppliers} />;
export const UsersPage = () => <UsersPermissions/>;
export const SitesPage = () => <CrudPage config={resources.locations} />;
